import React from "react";
import WebDevelopment from "./WebDevelopment";
import GraphicDesign from "./GraphicDesign";
import Illustration from "./Illustration";
import TraditionalPainting from "./TraditionalPainting";

const Portfolio = () => {
  return (
    <div id="portfolio" className="portfolio-wrapper">
      <div className="container">
        <h1 className="text-uppercase text-center py-5">Portfolio</h1>

        {/* Web Development */}
        <h2 className="text-uppercase text-center">Web Development</h2>
        <p className="text-center">
          Front-end, Back-end, Full-stack, and UI/UX design
        </p>
        <WebDevelopment />
        <hr />

        {/* Graphic Design */}
        <h2 className="text-uppercase text-center">Graphic Design</h2>
        <p className="text-center">Print and digital materials</p>
        <GraphicDesign />
        <hr />

        {/* Illustration */}
        <h2 className="text-uppercase text-center">Illustration</h2>
        <p className="text-center">Original and fan-made creations</p>
        <Illustration />
        <hr />

        {/* Traditional Painting */}
        <h2 className="text-uppercase text-center">Traditional Painting</h2>
        <p className="text-center">Oil, Acrlyic, and Gouache mediums</p>
        <TraditionalPainting />
      </div>
    </div>
  );
};

export default Portfolio;
